const ARABIC_PLURAL_FORM_COUNT = 6

const PLURAL_FORM = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  FEW: 3,
  MANY: 4,
  OTHER: 5,
}

// Mirrors vue-i18n 8's built-in rule. Applied when an Arabic lookup resolves to a
// message without six forms (e.g. the English fallback), because vue-i18n picks the
// rule by the ACTIVE locale.
const englishStylePluralIndex = (count, formCount) => {
  if (formCount === 2) {
    if (!count) return 1
    return count > 1 ? 1 : 0
  }
  return count ? Math.min(count, 2) : 0
}

/**
 * CLDR plural rule for Arabic, in vue-i18n `pluralizationRules` shape.
 * An Arabic plural message lists six pipe-separated forms in CLDR order:
 * zero | one | two | few (n % 100 in 3..10) | many (n % 100 in 11..99) | other.
 */
const arabicPluralizationRule = (choice, choicesLength) => {
  const count = Math.abs(choice)
  if (choicesLength !== ARABIC_PLURAL_FORM_COUNT) return englishStylePluralIndex(count, choicesLength)
  if (!Number.isInteger(count)) return PLURAL_FORM.OTHER
  if (count === 0) return PLURAL_FORM.ZERO
  if (count === 1) return PLURAL_FORM.ONE
  if (count === 2) return PLURAL_FORM.TWO
  const lastTwoDigits = count % 100
  if (lastTwoDigits >= 3 && lastTwoDigits <= 10) return PLURAL_FORM.FEW
  if (lastTwoDigits >= 11) return PLURAL_FORM.MANY
  return PLURAL_FORM.OTHER
}

export const pluralizationRules = {
  ar: arabicPluralizationRule,
}
